import { NocfoTheme } from '../styled'
import nocfoTheme from './nocfo'

const theme: NocfoTheme = {
  ...nocfoTheme,
  colors: {
    neutralBlack: '#000000',
    neutralGray: '#f2f4f7',
    neutralWhite: '#FFFFFF',
    iconGray: '#73808C',
    iconGrayDark: '#3B4A57',
    mutedYellow: '#F7CC7A',
    primary: '#A8C241',
    info: '#1b98f5',
    success: '#A8C241',
    error: '#f50d05',
    warning: '#ffa600',
    AIPurple: '#c000ec',
    menuBg: '#031e33',
    metalGray: '#3e444e',
    backdrop: '#435a6f66',
    defaultHover: '#f6f7f9',
    dashboardPos: '#031e33',
    dashboardNeg: '#ff576f',
    dashboardExtra1: '#E0E71D',
    dashboardExtra2: '#A8C241',
    ifBlue: '#0054f0',
    kraviaOrange: '#ff5e29',
    borderSoft: '#E4E8EC',
    borderStrong: '#CFD6DD'
  },
  assets: {
    logo: 'https://cdn.nocfo.io/third-party/tiliviesti/logo-basic.svg',
    logoLight: 'https://cdn.nocfo.io/third-party/tiliviesti/logo-light.svg'
  }
}

export default theme
